module.exports = __webpack_public_path__ + "static/media/broof_footer_logo.a23ceea9.png";